{
  "enum": {
    "ExcJaneStreetV1PfofJobStatus": {
      "FAILED": "Failed",
      "PROCESSED": "Processed",
      "RECEIVED": "Received",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcJaneStreetV1PfofJobQueryServicePfofJobListFilterableFields": {
      "jobId": "Job",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcJaneStreetV1PfofJobEventType": {
      "failed": "Failed",
      "processed": "Processed",
      "received": "Received"
    }
  },
  "sortEnum": {
    "ExcJaneStreetV1PfofJobQueryServicePfofJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}